/* ============================================================
   ALVARA HOME - shared engine
   Ported from the approved prototype (2026-07-31).
   Cart, drawer, and menu are owned by the Horizon theme; this file
   drives the brand choreography (overture, root map, spine), the
   buy-box plan toggle over real product forms, and the opt-in gate.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Chromium computes dash patterns in USER units when
     vector-effect: non-scaling-stroke is applied, ignoring pathLength
     normalization. Normalize every drawn stroke to its measured length. */
  function normDash(p, hidden) {
    if (!p) return;
    try { p.__L = p.getTotalLength(); } catch (e) { p.__L = 1; }
    p.style.strokeDasharray = p.__L + ' ' + p.__L;
    if (hidden) p.style.strokeDashoffset = p.__L;
  }

  /* ---------- Scroll reveals ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Count-up stats ---------- */
  if ('IntersectionObserver' in window && !reduced) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null, dur = 1100;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        el.textContent = '0' + suffix;
        requestAnimationFrame(step);
      });
    }, { threshold: .6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Pollen drift (hero) ---------- */
  var pollen = $('#pollen');
  if (pollen && !reduced) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 22; i++) {
      var p = document.createElement('i');
      p.style.left = (Math.random() * 100) + '%';
      p.style.animationDuration = (13 + Math.random() * 16) + 's';
      p.style.animationDelay = (-Math.random() * 22) + 's';
      p.style.opacity = (.3 + Math.random() * .5);
      p.style.transform = 'scale(' + (.5 + Math.random()) + ')';
      frag.appendChild(p);
    }
    pollen.appendChild(frag);
  }

  /* ---------- Honey scroll rail ---------- */
  var railFill = $('#railFill');
  if (railFill) {
    var ticking = false;
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      railFill.style.height = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ============================================================
     OVERTURE SCRUB - persistent rAF, never gated behind scroll
     events; lerp-smoothed with snap threshold.
     ============================================================ */
  var ovSec = $('#overture');
  if (ovSec) {
    if ('IntersectionObserver' in window) {
      /* 2026-08-19: hidden start state is opt-in (.ov-anim), so a script that
         never runs leaves the words painted, and the scroll fallback below
         mirrors the root-map unlock: a missed observer notification (fast
         scroll, restored tab, back-navigation) can never leave a line
         invisible for the rest of the page's life. */
      ovSec.classList.add('ov-anim');
      var wio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); wio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      var ovLines = $$('.wline', ovSec);
      ovLines.forEach(function (el) { wio.observe(el); });
      var ovWFallback = function () {
        var pending = false;
        ovLines.forEach(function (el) {
          if (el.classList.contains('in')) return;
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * .88 && r.bottom > 0) el.classList.add('in');
          else pending = true;
        });
        if (!pending) {
          window.removeEventListener('scroll', ovWFallback);
          window.removeEventListener('pageshow', ovWFallback);
        }
      };
      window.addEventListener('scroll', ovWFallback, { passive: true });
      window.addEventListener('pageshow', ovWFallback);
      ovWFallback();
    } else {
      $$('.wline', ovSec).forEach(function (el) { el.classList.add('in'); });
    }

    if (!reduced) {
      ovSec.classList.add('ov-live');
      var ovMain = $('#ovThreadMain'), ovTail = $('#ovThreadTail'),
          ovBell = $('#ovBell'), ovHexEl = $('#ovHex'), ovYou = $('#ovYou');
      $$('.ov-thread path', ovSec).forEach(function (p) { normDash(p, true); });
      normDash(ovHexEl, true);
      var ovNet = $$('.ov-net', ovSec);
      ovNet.forEach(function (p) {
        var w = p.getAttribute('data-w').split(',');
        p.__a = +w[0]; p.__b = +w[1];
      });
      var ovTips = $$('.ov-tip', ovSec);
      ovTips.forEach(function (c) { c.__w = +c.getAttribute('data-w'); });

      var ovTop = 0, ovSpan = 1;
      var ovMeasure = function () {
        var r = ovSec.getBoundingClientRect();
        ovTop = r.top + window.scrollY;
        ovSpan = Math.max(ovSec.offsetHeight - window.innerHeight * .45, 1);
      };
      ovMeasure();
      window.addEventListener('resize', ovMeasure);
      window.addEventListener('load', ovMeasure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ovMeasure);
      var ovDrawn = -1, ovRung = false;
      var ovSeg = function (p, a, b) { return Math.min(Math.max((p - a) / (b - a), 0), 1); };
      (function ovLoop() {
        var t = Math.min(Math.max((window.scrollY + window.innerHeight * .5 - ovTop) / ovSpan, 0), 1);
        if (ovDrawn < 0) ovDrawn = t;
        ovDrawn += (t - ovDrawn) * .12;
        if (Math.abs(t - ovDrawn) < .0005) ovDrawn = t;
        if (ovMain) ovMain.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .04, .68)) * ovMain.__L;
        if (ovTail) ovTail.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .78, 1)) * ovTail.__L;
        for (var ni = 0; ni < ovNet.length; ni++) {
          ovNet[ni].style.strokeDashoffset = (1 - ovSeg(ovDrawn, ovNet[ni].__a, ovNet[ni].__b)) * ovNet[ni].__L;
        }
        for (var ti = 0; ti < ovTips.length; ti++) {
          ovTips[ti].style.opacity = .75 * ovSeg(ovDrawn, ovTips[ti].__w - .02, ovTips[ti].__w + .05);
        }
        var b = ovSeg(ovDrawn, .56, .72);
        if (ovBell) {
          ovBell.style.opacity = b;
          ovBell.style.letterSpacing = (.06 - .055 * b) + 'em';
          ovBell.style.transform = 'scale(' + (.985 + .015 * b) + ')';
        }
        if (ovHexEl) ovHexEl.style.strokeDashoffset = (1 - ovSeg(ovDrawn, .62, .74)) * ovHexEl.__L;
        if (!ovRung && ovDrawn > .74 && ovYou) { ovRung = true; ovYou.classList.add('rung'); }
        requestAnimationFrame(ovLoop);
      })();
    }
  }

  /* ============================================================
     ROOT MAP + SPINE SCRUB - runtime-anchored, write-only frames.
     ============================================================ */
  var rmSec = $('.rootmap');
  if (rmSec) {
    var rmPinEl = $('#rmPin'), rmStage = $('#rmStage');
    /* 2026-08-03 feedback round: the 205vh sticky scrub registered as a
       scroll freeze on desktop reviewers' machines. Flow mode everywhere:
       natural height, IO-triggered CSS line draw, no pin. */
    var rmPinMode = false;
    rmSec.classList.add(rmPinMode ? 'rm-pinmode' : 'rm-flowmode');
    /* 2026-08-08: opt into the hidden start state only now that the script is
       demonstrably running. Everything in this section paints by default
       otherwise, so a script that never loads or throws above this line leaves
       the content visible instead of leaving an empty black band. Must stay
       ahead of the observer setup below. */
    rmSec.classList.add('rm-anim');

    var rmCores = [], rmGlows = [], rmMotes = [], rmNodes = [];
    for (var ri = 0; ri < 6; ri++) {
      rmCores.push($('#rmC' + ri));
      rmMotes.push($('.rm-mote[data-m="' + ri + '"]', rmSec));
      rmNodes.push($('.rm-node[data-n="' + ri + '"]', rmSec));
    }
    $$('.rm-glow', rmSec).forEach(function (p) { if (!p.id) rmGlows.push(p); });
    $$('.rm-svg path', rmSec).forEach(function (p) { normDash(p, !reduced); });
    normDash($('#rmHex'), !reduced);

    function placeMotes() {
      rmCores.forEach(function (path, i) {
        if (!path || !rmMotes[i]) return;
        try {
          var pt = path.getPointAtLength(path.getTotalLength() * .7);
          rmMotes[i].style.left = pt.x + '%';
          rmMotes[i].style.top = pt.y + '%';
        } catch (e) {}
      });
    }
    placeMotes();

    if (window.matchMedia('(hover: hover)').matches) {
      rmNodes.forEach(function (node, i) {
        if (!node) return;
        node.addEventListener('mouseenter', function () {
          node.classList.add('hot');
          if (rmCores[i]) rmCores[i].classList.add('hot');
          var root = $('#rmRoot');
          if (root) { root.classList.remove('pulse'); void root.offsetWidth; root.classList.add('pulse'); }
        });
        node.addEventListener('mouseleave', function () {
          node.classList.remove('hot');
          if (rmCores[i]) rmCores[i].classList.remove('hot');
        });
      });
    }

    if (!rmPinMode) {
      /* 2026-08-07: this observed #rmStage only, and #rmStage has zero
         height. A zero area target plus the -14% bottom inset leaves a very
         narrow band in which it can report as intersecting, and there was no
         fallback, so a single miss (fast scroll, a late layout shift, a
         restored tab, a back-navigation) left .rm-pin without .in and the
         whole map hidden at opacity 0 for the rest of the page's life. That
         paints as a black band and matches the intermittent report.
         Now: observe the section, which has real height; keep the stage as a
         second chance; and add a passive scroll fallback that unlocks at the
         same visual moment, so the animation still plays but can never be
         the thing standing between a visitor and the content. */
      var rmUnlock = function () {
        if (rmPinEl && !rmPinEl.classList.contains('in')) rmPinEl.classList.add('in');
      };
      if ('IntersectionObserver' in window && rmPinEl) {
        var rio = new IntersectionObserver(function (es) {
          for (var rz = 0; rz < es.length; rz++) {
            if (es[rz].isIntersecting) { rmUnlock(); rio.disconnect(); return; }
          }
        }, { rootMargin: '0px 0px -14% 0px' });
        rio.observe(rmSec);
        if (rmStage) rio.observe(rmStage);

        var rmFallback = function () {
          if (!rmPinEl || rmPinEl.classList.contains('in')) {
            window.removeEventListener('scroll', rmFallback);
            return;
          }
          var rr = rmSec.getBoundingClientRect();
          if (rr.top < window.innerHeight * .92 && rr.bottom > 0) {
            rmUnlock();
            window.removeEventListener('scroll', rmFallback);
          }
        };
        window.addEventListener('scroll', rmFallback, { passive: true });
        window.addEventListener('pageshow', rmFallback);
        rmFallback();
      } else {
        rmUnlock();
      }
    }

    var rmTop = 0, rmSpan = 1;
    function rmMeasure() {
      var r = rmSec.getBoundingClientRect();
      rmTop = r.top + window.scrollY;
      rmSpan = Math.max(rmSec.offsetHeight - window.innerHeight, 1);
      placeMotes();
    }
    rmMeasure();
    window.addEventListener('resize', rmMeasure);
    window.addEventListener('load', rmMeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(rmMeasure);

    if (!reduced) {
      var rmDrawn = -1;
      var seg2 = function (p, a, b) { return Math.min(Math.max((p - a) / (b - a), 0), 1); };
      var thWin = function (i) { return [.10 + i * .045, .36 + i * .045]; };
      var elHex = $('#rmHex'), elHalo = $('#rmHalo'), elTail = $('#rmTail'),
          elTailG = $('#rmTailG'), elDawn = $('#rmDawn');

      (function rmLoop() {
        if (rmPinMode && rmPinEl) {
          var t = Math.min(Math.max((window.scrollY - rmTop) / rmSpan, 0), 1);
          if (rmDrawn < 0) rmDrawn = t;
          rmDrawn += (t - rmDrawn) * .14;
          if (Math.abs(t - rmDrawn) < .0005) rmDrawn = t;
          var p = rmDrawn;

          /* Copy latches once revealed (scrolling back up must never
             hide content); the drawn ornament stays bidirectional. */
          if (p >= .02) rmPinEl.classList.add('p-eye');
          if (p >= .60) rmPinEl.classList.add('p-s1');
          if (p >= .70) rmPinEl.classList.add('p-s2');
          if (p >= .79) rmPinEl.classList.add('p-fl');
          if (p >= .84) rmPinEl.classList.add('p-cp');
          if (p >= .91) rmPinEl.classList.add('p-cta');

          for (var i = 0; i < 6; i++) {
            if (!rmCores[i]) continue;
            var w = thWin(i);
            var off = 1 - seg2(p, w[0], w[1]);
            rmCores[i].style.strokeDashoffset = off * rmCores[i].__L;
            if (rmGlows[i]) rmGlows[i].style.strokeDashoffset = off * rmGlows[i].__L;
            var o = .35 * seg2(p, .01 + i * .02, .04 + i * .02)
                  + .55 * seg2(p, w[0], w[0] + .06)
                  - .40 * seg2(p, .66, .74);
            if (rmNodes[i]) rmNodes[i].style.opacity = o;
            var segP = seg2(p, w[0], w[1]);
            if (rmMotes[i]) {
              if (segP >= .7 && !rmMotes[i].classList.contains('go')) rmMotes[i].classList.add('go');
              else if (segP < .62 && rmMotes[i].classList.contains('go')) rmMotes[i].classList.remove('go');
            }
          }
          if (elHex) elHex.style.strokeDashoffset = (1 - seg2(p, .58, .68)) * elHex.__L;
          if (elHalo) elHalo.style.opacity = seg2(p, .66, .74);
          var tailOff = 1 - seg2(p, .88, 1);
          if (elTail) elTail.style.strokeDashoffset = tailOff * elTail.__L;
          if (elTailG) elTailG.style.strokeDashoffset = tailOff * elTailG.__L;
          if (elDawn) elDawn.style.opacity = .85 * seg2(p, .86, 1);
        }

        requestAnimationFrame(rmLoop);
      })();
    }
  }

  /* ============================================================
     FORMULATION SPINE - independent since 2026-08-19. This setup
     previously lived inside the root-map block above, so switching
     the root-map section off in the theme editor also removed the
     only code that reveals the four formulation cards, and "Nourish
     Every System" painted as an empty cream band for any visitor
     without reduced motion. The spine now initializes on its own,
     opts into the hidden start state only once the script is
     actually running (.sp-anim), and carries an unlock guard so
     content can never hide behind the animation.
     ============================================================ */
  var spSec = $('#coherence');
  var spWrap = $('#spWrap'), spSpine = $('#spSpine'), spBridge = $('#spBridge'),
      spGrid = $('#spGrid'), spCaption = $('#spCaption');
  if (spSec && spWrap && spSpine) {
    var spCards = $$('.coh-card', spWrap).sort(function (a, b) {
      return (+a.getAttribute('data-st')) - (+b.getAttribute('data-st'));
    });
    var spX = 50, spFracs = [0, 0, 0, 0], spBridgeAt = 1, spReady = false, spBridgeGone = false;
    var pct = function (v, whole) { return (v / whole) * 100; };

    var spMeasure = function () {
      var wr = spWrap.getBoundingClientRect();
      if (wr.height < 10) return;
      var mobile = window.matchMedia('(max-width: 880px)').matches;
      if (mobile) {
        spX = pct(14, wr.width);
      } else if (spGrid) {
        var gr = spGrid.getBoundingClientRect();
        spX = pct((gr.left + gr.width / 2) - wr.left, wr.width);
      }
      spSpine.setAttribute('d', 'M' + spX + ' 0 L' + spX + ' 100');
      normDash(spSpine, !reduced);
      spCards.forEach(function (card, i) {
        var cr = card.getBoundingClientRect();
        spFracs[i] = ((cr.top + 46) - wr.top) / wr.height;
      });
      var r1 = $('#rei1'), r2 = $('#rei2');
      if (r1 && r2 && spBridge) {
        var a = r1.getBoundingClientRect(), b2 = r2.getBoundingClientRect();
        var ax = pct(a.left + a.width / 2 - wr.left, wr.width), ay = pct(a.bottom + 6 - wr.top, wr.height);
        var bx = pct(b2.left + b2.width / 2 - wr.left, wr.width), by = pct(b2.top - 8 - wr.top, wr.height);
        var mx = spX, my = (ay + by) / 2;
        spBridge.setAttribute('d', 'M' + ax + ' ' + ay + ' C ' + ax + ' ' + (ay + 7) + ', ' + mx + ' ' + (my - 9) + ', ' + mx + ' ' + my +
          ' C ' + mx + ' ' + (my + 9) + ', ' + bx + ' ' + (by - 7) + ', ' + bx + ' ' + by);
        normDash(spBridge, !spBridgeGone && !reduced);
        spBridgeAt = Math.max(spFracs[3], my / 100) + .04;
      }
      spReady = true;
    };
    spMeasure();
    window.addEventListener('resize', spMeasure);
    window.addEventListener('load', spMeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(spMeasure);

    if (!reduced && 'IntersectionObserver' in window) {
      /* Hidden start state is opt-in: without this class (script absent,
         script dead, reduced motion) every card paints by default. */
      spSec.classList.add('sp-anim');
      var spDrawn = -1, spPeak = 0;
      var spSeg = function (p, a, b) { return Math.min(Math.max((p - a) / (b - a), 0), 1); };
      var spFinish = function () {
        setTimeout(function () {
          var a1 = $('#rei1'), a2 = $('#rei2');
          if (a1) a1.classList.add('lit');
          if (a2) a2.classList.add('lit');
          if (spCaption) spCaption.classList.add('on');
        }, 1250);
      };
      var spUnlockAll = function () {
        spCards.forEach(function (c) { c.classList.add('st-on'); });
        if (spBridge && !spBridgeGone) { spBridgeGone = true; spBridge.classList.add('go'); spFinish(); }
        spSec.classList.remove('sp-anim');
      };
      (function spLoop() {
        if (spReady) {
          var wrTop2 = spWrap.getBoundingClientRect().top;
          var bp = Math.min(Math.max((window.innerHeight * .82 - wrTop2) / spWrap.offsetHeight, 0), 1);
          if (spDrawn < 0) spDrawn = bp;
          spDrawn += (bp - spDrawn) * .14;
          if (Math.abs(bp - spDrawn) < .0005) spDrawn = bp;
          var fracNow = spSeg(spDrawn, .02, .92);
          /* Monotonic: the ink never un-draws, cards never un-reveal. */
          if (fracNow > spPeak) spPeak = fracNow;
          var frac = spPeak;
          spSpine.style.strokeDashoffset = (1 - frac) * spSpine.__L;
          for (var s = 0; s < 4; s++) {
            if (!spCards[s]) continue;
            if (frac >= spFracs[s]) spCards[s].classList.add('st-on');
          }
          if (!spBridgeGone && frac >= spBridgeAt && spBridge) {
            spBridgeGone = true;
            spBridge.classList.add('go');
            spFinish();
          }
        }
        requestAnimationFrame(spLoop);
      })();
      /* Watchdog: if the scrub loop ever stops keeping up with the scroll
         position while cards are still hidden, paint everything. Never fires
         while the loop is healthy; pageshow re-measures after a Safari
         back-forward cache restore. */
      var spGuard = setInterval(function () {
        var allOn = true;
        for (var q = 0; q < spCards.length; q++) {
          if (!spCards[q].classList.contains('st-on')) { allOn = false; break; }
        }
        if (allOn) { clearInterval(spGuard); return; }
        var wr = spWrap.getBoundingClientRect();
        if (wr.top > window.innerHeight || wr.bottom < 0) return;
        var expect = spSeg(Math.min(Math.max((window.innerHeight * .82 - wr.top) / spWrap.offsetHeight, 0), 1), .02, .92);
        if (expect - spPeak > .15) spUnlockAll();
      }, 1500);
      window.addEventListener('pageshow', function (ev) {
        if (ev && ev.persisted) spMeasure();
      });
    }
  }

  var cohSec = $('#coherence');
    if (cohSec) {
      var setHot = function (c, on) {
        $$('.cmp[data-c="' + c + '"]', cohSec).forEach(function (el) { el.classList.toggle('hotc', on); });
      };
      cohSec.addEventListener('mouseover', function (e) {
        var t = e.target.closest('.cmp'); if (t) setHot(t.getAttribute('data-c'), true);
      });
      cohSec.addEventListener('mouseout', function (e) {
        var t = e.target.closest('.cmp'); if (t) setHot(t.getAttribute('data-c'), false);
      });
      cohSec.addEventListener('click', function (e) {
        var t = e.target.closest('.cmp');
        $$('.cmp.hotc', cohSec).forEach(function (el) { el.classList.remove('hotc'); });
        if (t) setHot(t.getAttribute('data-c'), true);
      });
    }

  /* ============================================================
     BUY: plan toggle over two REAL product forms.
     The forms are Horizon <product-form-component> instances; the
     theme handles AJAX add + cart drawer. This JS only decides
     which form is active.
     ============================================================ */
  var optSub = $('#opt-sub'), optOnce = $('#opt-once');
  var formSub = $('#alvara-form-sub'), formOnce = $('#alvara-form-once');
  var satcPrice = $('#satcPrice');
  function activeForm() {
    return (optOnce && optOnce.classList.contains('sel')) ? formOnce : formSub;
  }
  function selectPlan(which) {
    if (!optSub || !optOnce) return;
    optSub.classList.toggle('sel', which === 'sub');
    optOnce.classList.toggle('sel', which === 'once');
    var rs = $('#rad-sub'), ro = $('#rad-once');
    if (rs) rs.checked = which === 'sub';
    if (ro) ro.checked = which === 'once';
    if (formSub) formSub.classList.toggle('bb-form-hidden', which !== 'sub');
    if (formOnce) formOnce.classList.toggle('bb-form-hidden', which !== 'once');
    if (satcPrice) {
      satcPrice.innerHTML = which === 'sub'
        ? (satcPrice.getAttribute('data-sub') || '')
        : (satcPrice.getAttribute('data-once') || '');
    }
  }
  if (optSub && optOnce) {
    optSub.addEventListener('click', function () { selectPlan('sub'); });
    optOnce.addEventListener('click', function () { selectPlan('once'); });
    selectPlan('sub');
  }

  /* Any [data-add] CTA submits the active (or subscription) product
     form through the theme's AJAX pipeline; falls back to scrolling
     to the buy section. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    if (btn.closest('form')) return; /* real submit buttons pass through */
    e.preventDefault();
    var form = (btn.getAttribute('data-add') === 'once' && formOnce) ? formOnce : (formSub || formOnce);
    var submit = form ? form.querySelector('button[type="submit"], button[name="add"]') : null;
    if (submit && !submit.disabled) {
      submit.click();
    } else {
      var buySec = $('#buy');
      if (buySec) buySec.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    }
  });

  /* ---------- Sticky ATC: silent until the overture has played ---------- */
  var stickyBar = $('#stickyAtc'), atcGate = $('#overture') || $('.alvara-hero'), buySec2 = $('#buy');
  if (stickyBar && buySec2 && 'IntersectionObserver' in window) {
    var pastGate = false, buyVisible = false;
    var updateSticky = function () {
      var show = pastGate && !buyVisible;
      stickyBar.classList.toggle('show', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
    };
    if (atcGate) {
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        pastGate = !e.isIntersecting && e.boundingClientRect.top < 0;
        updateSticky();
      }); }).observe(atcGate);
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { buyVisible = e.isIntersecting; updateSticky(); }); }, { threshold: .25 }).observe(buySec2);
  }

  /* ============================================================
     LAYERS: opt-in modal + video lightbox (scrim shared).
     ============================================================ */
  var scrim = $('#alvaraScrim'), optin = $('#optin'), lightbox = $('#lightbox');
  var openLayer = null, lastFocus = null;

  function focusables(root) {
    return $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function openLayerEl(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    openLayer = el;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('on'); }); }
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('alvara-locked');
    var target = focusSel ? $(focusSel, el) : null;
    setTimeout(function () { (target || focusables(el)[0] || el).focus(); }, 90);
  }
  function closeLayer() {
    if (!openLayer) return;
    openLayer.classList.remove('on');
    openLayer.setAttribute('aria-hidden', 'true');
    if (openLayer === lightbox) { var f = $('#lbFrame'); if (f) f.innerHTML = ''; }
    if (scrim) {
      scrim.classList.remove('on');
      setTimeout(function () { scrim.hidden = true; }, 350);
    }
    document.body.classList.remove('alvara-locked');
    openLayer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (scrim) scrim.addEventListener('click', closeLayer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openLayer) closeLayer();
    if (e.key === 'Tab' && openLayer) {
      var f = focusables(openLayer);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  var optinClose = $('#optinClose'); if (optinClose) optinClose.addEventListener('click', closeLayer);
  var lbClose = $('#lbClose'); if (lbClose) lbClose.addEventListener('click', closeLayer);
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLayer(); });
  if (optin) optin.addEventListener('click', function (e) { if (e.target === optin) closeLayer(); });

  document.addEventListener('click', function (e) {
    var oi = e.target.closest('[data-optin]');
    if (oi) { e.preventDefault(); openLayerEl(optin, '#optinEmail'); }
  });

  /* Native customer-form capture: Shopify posts and redirects back.
     On return, surface the right success state (and the gated code). */
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    var which = window.location.hash;
    if (which === '#optin-ok' && optin) {
      var ofrm = $('#optinFormWrap'), orev = $('#optinReveal');
      if (ofrm) ofrm.style.display = 'none';
      if (orev) {
        var codeEl = $('#optinCode');
        if (codeEl && optin.getAttribute('data-code')) codeEl.textContent = optin.getAttribute('data-code');
        orev.classList.add('on');
      }
      openLayerEl(optin);
    }
    if (which === '#hive-ok') {
      var hf = $('#hiveForm'), ok = $('#hiveOk');
      if (hf) hf.style.display = 'none';
      if (ok) { ok.classList.add('on'); ok.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); }
    }
  }
  var optinCopy = $('#optinCopy');
  if (optinCopy) optinCopy.addEventListener('click', function () {
    var codeEl2 = $('#optinCode');
    if (codeEl2 && navigator.clipboard) navigator.clipboard.writeText(codeEl2.textContent.trim());
    this.textContent = 'Copied';
  });

  /* ---------- Video lightbox (no YouTube request until click) ---------- */
  $$('[data-yt]').forEach(function (card) {
    card.addEventListener('click', function () {
      var id = card.getAttribute('data-yt');
      var title = card.getAttribute('data-title') || 'ALVARA video';
      var frame = $('#lbFrame');
      if (!frame || !lightbox) return;
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="' + title +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      openLayerEl(lightbox, '#lbClose');
    });
  });
})();
/* ===== PDP LAYER ===== */
/* ===== alvara-pdp-hero ===== */
try {
/* ALVARA PDP Hero + Path Chooser: path selection, CTA label + target form.
   Scoped per section root so multiple instances can live on one page. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.pdhReady === '1') return;
    root.dataset.pdhReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.pdh-card'));
    var cta = root.querySelector('.pdh-cta');
    if (!cards.length) return;

    var ctaText = cta ? cta.querySelector('.pdh-cta-t') : null;

    function applyPath(key) {
      if (!key) return;

      cards.forEach(function (card) {
        var on = card.getAttribute('data-path') === key;
        card.classList.toggle('sel', on);
        var radio = card.querySelector('.pdh-radio');
        if (radio && radio.checked !== on) radio.checked = on;
      });

      if (!cta) return;

      var formId = cta.getAttribute('data-form-' + key) || '';
      var label = cta.getAttribute('data-label-' + key) || '';
      var targetForm = formId ? document.getElementById(formId) : null;

      if (targetForm) {
        cta.setAttribute('form', formId);
        cta.disabled = false;
        cta.removeAttribute('aria-disabled');
      } else {
        cta.removeAttribute('form');
        cta.disabled = true;
        cta.setAttribute('aria-disabled', 'true');
      }

      if (label && ctaText) ctaText.textContent = label;
      cta.setAttribute('data-active-path', key);
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('.pdh-radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) applyPath(card.getAttribute('data-path'));
      });
    });

    var checked = root.querySelector('.pdh-radio:checked');
    var startCard = checked
      ? checked.closest('.pdh-card')
      : (root.querySelector('.pdh-card[data-default="true"]') || cards[0]);
    applyPath(startCard ? startCard.getAttribute('data-path') : null);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('.pdh[data-pdh]')) initSection(context);
    Array.prototype.forEach.call(
      context.querySelectorAll('.pdh[data-pdh]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();

} catch (e) { console.error("alvara-pdp-hero", e); }

/* ===== alvara-pdp-ingredients ===== */
try {
  document.querySelectorAll('.pin').forEach(function (sec) {
    var bigWrap = sec.querySelector('.pin-media-ing');
    var big = bigWrap ? bigWrap.querySelector('img') : null;
    sec.addEventListener('click', function (e) {
      var f = e.target.closest('.pin-filter');
      if (f) {
        sec.querySelectorAll('.pin-filter').forEach(function (x) { x.classList.toggle('is-on', x === f); x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        var cat = f.getAttribute('data-cat');
        sec.querySelectorAll('.pin-row').forEach(function (row) {
          row.classList.toggle('pin-hide', cat !== 'all' && row.getAttribute('data-cat') !== cat);
        });
        return;
      }
      var btn = e.target.closest('.pin-row-btn');
      if (!btn) return;
      var row = btn.closest('.pin-row');
      var wasOpen = row.classList.contains('is-open');
      sec.querySelectorAll('.pin-row.is-open').forEach(function (r) {
        r.classList.remove('is-open');
        r.querySelector('.pin-row-btn').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        row.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (big) {
          var thumb = row.querySelector('.pin-thumb img');
          if (thumb && big.getAttribute('src') !== thumb.getAttribute('src')) {
            bigWrap.classList.add('is-swapping');
            setTimeout(function () {
              big.src = thumb.src;
              big.onload = function () { bigWrap.classList.remove('is-swapping'); };
              setTimeout(function () { bigWrap.classList.remove('is-swapping'); }, 600);
            }, 180);
          }
        }
      }
    });
  });
} catch (e) { console.error('alvara-pdp-ingredients', e); }



/* ================= NINE PAGES JS (generated) ================= */

/* ================= END NINE PAGES JS ================= */

/* ================= ALVARA NAV JS (generated) ================= */
/* ============================================================
   ALVARA NAV  ·  Colophon
   Appended to assets/alvara-home.js. Vanilla, no dependencies.
   Open and closed state is driven by class toggles plus inert.
   Nothing here waits on a transitionend event.
   ============================================================ */
(function () {
  'use strict';

  try {

    var REDUCE_Q = '(prefers-reduced-motion: reduce)';

    function reduced() {
      try { return window.matchMedia && window.matchMedia(REDUCE_Q).matches; }
      catch (e) { return false; }
    }

    function isDesktop() {
      try { return window.matchMedia && window.matchMedia('(min-width: 768px)').matches; }
      catch (e) { return (window.innerWidth || 0) >= 768; }
    }

    function toArray(list) {
      return Array.prototype.slice.call(list || []);
    }

    function visible(el) {
      return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    /* ---------- shared sentinel for the condensed state ---------- */

    var sentinel = null;

    function getSentinel() {
      if (sentinel && sentinel.isConnected) return sentinel;
      sentinel = document.querySelector('.anav-sentinel');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.className = 'anav-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        if (document.body.firstChild) {
          document.body.insertBefore(sentinel, document.body.firstChild);
        } else {
          document.body.appendChild(sentinel);
        }
      }
      return sentinel;
    }

    /* ============================================================
       INIT
       ============================================================ */

    function initNav(root) {
      if (!root || root.__anavInit) return;
      root.__anavInit = true;

      var stack = root.querySelector('[data-anav-stack]');
      var section = root.closest ? root.closest('.shopify-section, .anav-section') : null;

      /* ---------------------------------------------------------
         A. HEADER HEIGHT  ->  --anav-h
         --------------------------------------------------------- */

      var lastH = 0;

      function measure() {
        try {
          if (!stack) return;
          var h = Math.round(stack.getBoundingClientRect().height);
          if (h > 0 && h !== lastH) {
            lastH = h;
            document.documentElement.style.setProperty('--anav-h', h + 'px');
          }
        } catch (e) { /* no-op */ }
      }

      measure();
      window.addEventListener('load', measure);
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(measure).catch(function () {});
      }

      if (window.ResizeObserver && stack) {
        try { new ResizeObserver(measure).observe(stack); } catch (e) { /* no-op */ }
      }

      /* ---------------------------------------------------------
         B. CONDENSED STATE  (IntersectionObserver sentinel)
         No scroll listener, no rAF gate, no deadlock.
         --------------------------------------------------------- */

      var scrollState = 'top';
      var stateFrozen = false;
      var pendingState = null;

      function applyState(next) {
        if (stateFrozen) { pendingState = next; return; }
        if (next === scrollState) return;
        scrollState = next;
        root.setAttribute('data-scroll', next);
        measure();
      }

      function freezeState(on) {
        stateFrozen = !!on;
        if (!stateFrozen && pendingState) {
          var p = pendingState;
          pendingState = null;
          applyState(p);
        }
      }

      root.setAttribute('data-scroll', 'top');

      if ('IntersectionObserver' in window) {
        try {
          var io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              applyState(entries[i].isIntersecting ? 'top' : 'past');
            }
          }, { threshold: 0, rootMargin: '-64px 0px 0px 0px' });
          io.observe(getSentinel());
        } catch (e) {
          applyState('top');
        }
      } else {
        window.addEventListener('scroll', function () {
          applyState((window.pageYOffset || 0) > 64 ? 'past' : 'top');
        }, { passive: true });
      }

      /* ---------------------------------------------------------
         C. PROMO TICKER
         --------------------------------------------------------- */

      var tick = root.querySelector('[data-atick]');
      var tickTrack = root.querySelector('[data-atick-track]');
      var tickSet = root.querySelector('[data-atick-set]');
      var tickPause = root.querySelector('[data-atick-pause]');
      var tickW = window.innerWidth || 0;

      function tickSpeed() {
        var v = parseFloat(root.getAttribute('data-tick-speed'));
        if (!v || v < 8) v = 34;
        return v;
      }

      function layoutTicker() {
        try {
          if (!tickTrack || !tickSet || reduced()) return;

          while (tickTrack.children.length > 1) {
            tickTrack.removeChild(tickTrack.lastChild);
          }

          var setW = tickSet.getBoundingClientRect().width;
          if (!setW || setW < 4) return;

          var vw = window.innerWidth || document.documentElement.clientWidth || 1280;
          var k = Math.max(1, Math.ceil(vw / setW));
          var copies = k * 2;

          var frag = document.createDocumentFragment();
          for (var i = 1; i < copies; i++) {
            var clone = tickSet.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            frag.appendChild(clone);
          }
          tickTrack.appendChild(frag);

          var dur = (k * setW) / tickSpeed();
          if (!isFinite(dur) || dur <= 0) dur = 62;
          dur = Math.max(18, Math.min(240, dur));
          root.style.setProperty('--anav-tick-dur', dur.toFixed(2) + 's');
          tickW = vw;
        } catch (e) { /* no-op */ }
      }

      function setTickPaused(paused, persist) {
        try {
          root.setAttribute('data-tick-paused', paused ? '1' : '0');
          if (tickPause) {
            tickPause.setAttribute('aria-pressed', paused ? 'true' : 'false');
            tickPause.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
          }
          if (persist) {
            try { window.sessionStorage.setItem('alv_tick_paused', paused ? '1' : '0'); }
            catch (e) { /* storage blocked */ }
          }
        } catch (e) { /* no-op */ }
      }

      if (tick && tickTrack) {
        var startPaused = false;
        try { startPaused = window.sessionStorage.getItem('alv_tick_paused') === '1'; }
        catch (e) { startPaused = false; }
        setTickPaused(startPaused, false);

        layoutTicker();
        if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
          document.fonts.ready.then(layoutTicker).catch(function () {});
        }
        window.addEventListener('load', layoutTicker);

        if (tickPause) {
          tickPause.addEventListener('click', function () {
            setTickPaused(root.getAttribute('data-tick-paused') !== '1', true);
          });
        }
      }

      /* ---------------------------------------------------------
         D. MEGA PANELS
         --------------------------------------------------------- */

      var parents = toArray(root.querySelectorAll('[data-anav-parent]'));
      var panels = {};
      toArray(root.querySelectorAll('[data-anav-panel]')).forEach(function (p) {
        panels[p.getAttribute('data-anav-panel')] = p;
      });

      var openKey = null;
      var openedByKeyboard = false;
      var openScrollY = 0;
      var openTimer = null;
      var closeTimer = null;
      var suppressClick = false;

      function parentBtn(key) {
        for (var i = 0; i < parents.length; i++) {
          if (parents[i].getAttribute('data-anav-parent') === key) return parents[i];
        }
        return null;
      }

      function hidePanel(key) {
        var p = panels[key];
        if (!p) return;
        p.classList.remove('is-open');
        p.classList.remove('is-swap');
        try { p.setAttribute('inert', ''); } catch (e) { /* no-op */ }
        var b = parentBtn(key);
        if (b) b.setAttribute('aria-expanded', 'false');
      }

      function openPanel(key, viaKeyboard) {
        var p = panels[key];
        if (!p || !isDesktop()) return;

        var swap = !!openKey && openKey !== key;
        if (swap) hidePanel(openKey);

        openKey = key;
        openedByKeyboard = !!viaKeyboard;
        openScrollY = window.pageYOffset || 0;

        p.classList.toggle('is-swap', swap && !reduced());
        p.removeAttribute('inert');
        /* force a style flush so the entrance transition actually runs */
        void p.offsetWidth;
        p.classList.add('is-open');

        var b = parentBtn(key);
        if (b) b.setAttribute('aria-expanded', 'true');

        root.setAttribute('data-panel-open', key);
        freezeState(true);

        if (swap) {
          clearTimeout(p.__anavSwapT);
          p.__anavSwapT = setTimeout(function () { p.classList.remove('is-swap'); }, 700);
        }
      }

      function closePanels(returnFocus) {
        if (!openKey) return;
        var key = openKey;
        openKey = null;
        hidePanel(key);
        root.removeAttribute('data-panel-open');
        freezeState(false);
        if (returnFocus) {
          var b = parentBtn(key);
          if (b) { try { b.focus(); } catch (e) { /* no-op */ } }
        }
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (groupHasFocus()) return;
          closePanels(false);
        }, 220);
      }

      function groupHasFocus() {
        var a = document.activeElement;
        if (!a || !openKey) return false;
        var p = panels[openKey];
        if (p && p.contains(a)) return true;
        return a === parentBtn(openKey);
      }

      function firstFocusable(container) {
        if (!container) return null;
        var els = toArray(container.querySelectorAll('a[href], button:not([disabled])'));
        for (var i = 0; i < els.length; i++) { if (visible(els[i])) return els[i]; }
        return null;
      }

      parents.forEach(function (btn) {
        var key = btn.getAttribute('data-anav-parent');

        btn.addEventListener('pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          if (!isDesktop()) return;
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(function () { openPanel(key, false); }, 90);
        });

        btn.addEventListener('pointerleave', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          clearTimeout(openTimer);
          scheduleClose();
        });

        /* Hybrid touch laptops report hover:hover. Toggle on the down event
           and suppress the synthetic click so nothing fires twice. */
        btn.addEventListener('pointerdown', function (e) {
          if (!e.pointerType || e.pointerType === 'mouse') return;
          if (!isDesktop()) return;
          clearTimeout(openTimer);
          suppressClick = true;
          setTimeout(function () { suppressClick = false; }, 500);
          if (openKey === key) closePanels(false); else openPanel(key, false);
        });

        btn.addEventListener('click', function (e) {
          /* Touch already toggled the panel on pointerdown; swallow the
             synthetic click so a linked parent does not also navigate. */
          if (suppressClick) { e.preventDefault(); return; }
          /* A parent rendered as a real <a> navigates on click. Hover still
             opens its panel and ArrowDown still opens it for keyboard users,
             so nothing is lost by letting the click through. */
          if (btn.getAttribute('href')) return;
          e.preventDefault();
          if (!isDesktop()) return;
          clearTimeout(openTimer);
          var kb = (e.detail === 0);
          if (openKey === key) closePanels(kb); else openPanel(key, kb);
        });

        btn.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'Down') {
            e.preventDefault();
            openPanel(key, true);
            var f = firstFocusable(panels[key]);
            if (f) { try { f.focus(); } catch (err) { /* no-op */ } }
          } else if (e.key === 'Escape' || e.key === 'Esc') {
            closePanels(true);
          }
        });
      });

      Object.keys(panels).forEach(function (key) {
        var p = panels[key];

        p.addEventListener('pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          clearTimeout(closeTimer);
        });

        p.addEventListener('pointerleave', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          scheduleClose();
        });

        p.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.key === 'Esc') {
            e.stopPropagation();
            closePanels(true);
          }
        });
      });

      /* focus-within holds the panel open with no timer, and tabbing out of
         the parent-plus-panel group closes it. */
      if (stack) {
        stack.addEventListener('focusout', function () {
          setTimeout(function () {
            if (!openKey) return;
            if (groupHasFocus()) return;
            closePanels(false);
          }, 0);
        });
      }

      document.addEventListener('click', function (e) {
        if (!openKey) return;
        if (stack && stack.contains(e.target)) return;
        closePanels(false);
      });

      /* Panels ride the sticky wrapper, so they are never closed by an
         ordinary scroll. Only a long pointer-initiated jump closes them,
         and a keyboard-opened panel is exempt so magnifier users can pan. */
      window.addEventListener('scroll', function () {
        if (!openKey || openedByKeyboard) return;
        if (Math.abs((window.pageYOffset || 0) - openScrollY) > 240) closePanels(false);
      }, { passive: true });

      /* ---------------------------------------------------------
         E. MOBILE DRAWER
         --------------------------------------------------------- */

      var burger = root.querySelector('[data-anav-burger]');
      var drawer = root.querySelector('[data-anav-drawer]');
      var scrim = root.querySelector('[data-anav-scrim]');
      var utils = root.querySelector('[data-anav-utils]');
      var cartLink = root.querySelector('[data-anav-cart-link]');
      var accItems = toArray(root.querySelectorAll('[data-anav-acc]'));

      var drawerOpen = false;
      var savedY = 0;
      var inerted = [];

      function lockPage() {
        savedY = window.pageYOffset || 0;
        document.documentElement.classList.add('anav-locked');
      }

      function unlockPage() {
        document.documentElement.classList.remove('anav-locked');
        if (Math.abs((window.pageYOffset || 0) - savedY) > 2) {
          try { window.scrollTo(0, savedY); } catch (e) { /* no-op */ }
        }
      }

      function setPageInert(on) {
        try {
          if (on) {
            inerted = [];
            var keep = section || root;
            toArray(document.body.children).forEach(function (el) {
              if (el === keep || el.contains(keep) || el === sentinel) return;
              if (el.hasAttribute('inert')) return;
              el.setAttribute('inert', '');
              inerted.push(el);
            });
          } else {
            inerted.forEach(function (el) { el.removeAttribute('inert'); });
            inerted = [];
          }
        } catch (e) { inerted = []; }
      }

      function trapList() {
        return toArray(root.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          if (!visible(el)) return false;
          if (el.closest && el.closest('[inert]')) return false;
          return true;
        });
      }

      function onDrawerKey(e) {
        if (!drawerOpen) return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          closeDrawer(true);
          return;
        }
        if (e.key !== 'Tab') return;
        var list = trapList();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        var a = document.activeElement;
        if (e.shiftKey) {
          if (a === first || !root.contains(a)) { e.preventDefault(); try { last.focus(); } catch (err) {} }
        } else {
          if (a === last || !root.contains(a)) { e.preventDefault(); try { first.focus(); } catch (err) {} }
        }
      }

      function openDrawer() {
        if (drawerOpen || !drawer) return;
        closePanels(false);
        drawerOpen = true;
        lockPage();
        root.classList.add('is-drawer');
        drawer.removeAttribute('inert');
        if (burger) {
          burger.setAttribute('aria-expanded', 'true');
          burger.setAttribute('aria-label', 'Close menu');
        }
        setPageInert(true);
        freezeState(true);
        document.addEventListener('keydown', onDrawerKey, true);
        /* Focus the container, never a field: on Android the burger tap counts
           as the gesture and focusing an input raises the keyboard over the menu. */
        drawer.setAttribute('tabindex', '-1');
        try { drawer.focus({ preventScroll: true }); } catch (e) { try { drawer.focus(); } catch (err) {} }
      }

      function closeDrawer(returnFocus) {
        if (!drawerOpen || !drawer) return;
        drawerOpen = false;
        root.classList.remove('is-drawer');
        try { drawer.setAttribute('inert', ''); } catch (e) { /* no-op */ }
        if (burger) {
          burger.setAttribute('aria-expanded', 'false');
          burger.setAttribute('aria-label', 'Open menu');
        }
        setPageInert(false);
        unlockPage();
        freezeState(false);
        document.removeEventListener('keydown', onDrawerKey, true);
        if (returnFocus && burger) { try { burger.focus(); } catch (e) { /* no-op */ } }
      }

      if (burger) {
        burger.addEventListener('click', function (e) {
          e.preventDefault();
          if (drawerOpen) closeDrawer(true); else openDrawer();
        });
      }

      if (scrim) {
        scrim.addEventListener('click', function () { closeDrawer(false); });
        scrim.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
      }

      accItems.forEach(function (item) {
        var btn = item.querySelector('[data-anav-acc-btn]');
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          accItems.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var ob = other.querySelector('[data-anav-acc-btn]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });

      /* Cart handoff: close our drawer and release the lock first, then let
         Horizon open its own drawer. The two panels never overlap. */
      function themeCartButton() {
        if (!utils) return null;
        var els = toArray(utils.querySelectorAll('a, button'));
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          var hay = [
            el.getAttribute('aria-label') || '',
            el.getAttribute('class') || '',
            el.getAttribute('href') || '',
            el.getAttribute('data-testid') || ''
          ].join(' ').toLowerCase();
          if (hay.indexOf('cart') !== -1) return el;
        }
        return null;
      }

      if (cartLink) {
        cartLink.addEventListener('click', function (e) {
          var btn = themeCartButton();
          if (!btn) return; /* href is the fallback */
          e.preventDefault();
          var href = cartLink.getAttribute('href') || '/cart';
          closeDrawer(false);
          setTimeout(function () {
            try { btn.click(); }
            catch (err) { window.location.href = href; }
          }, 240);
        });
      }

      /* Any navigation inside the drawer closes it first. */
      if (drawer) {
        drawer.addEventListener('click', function (e) {
          var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
          if (!a || a === cartLink) return;
          closeDrawer(false);
        });
      }

      /* ---------------------------------------------------------
         F. GLOBAL KEYS + RESIZE
         --------------------------------------------------------- */

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (openKey) closePanels(true);
      });

      var resizeT = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () {
          var vw = window.innerWidth || 0;

          if (!isDesktop()) closePanels(false);
          if (isDesktop() && drawerOpen) closeDrawer(false);

          measure();

          /* Width only, never height: mobile browser chrome fires resize on
             every scroll direction change and a recompute restarts the loop. */
          if (!drawerOpen && !openKey && Math.abs(vw - tickW) > 40) layoutTicker();
        }, 150);
      });

      window.addEventListener('pageshow', function () {
        measure();
        if (drawerOpen) closeDrawer(false);
      });
    }

    /* ============================================================
       BOOT
       ============================================================ */

    function boot() {
      toArray(document.querySelectorAll('[data-anav]')).forEach(initNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      try {
        var el = e.target && e.target.querySelector ? e.target.querySelector('[data-anav]') : null;
        if (el) initNav(el);
      } catch (err) { /* no-op */ }
    });

    document.addEventListener('shopify:section:unload', function () {
      try { document.documentElement.classList.remove('anav-locked'); } catch (err) { /* no-op */ }
    });

  } catch (e) {
    /* The header must never take the page down with it. */
    if (window.console && console.warn) console.warn('[alvara-nav]', e);
  }
})();
/* ================= END ALVARA NAV JS ================= */
/* ================= ALVARA CART: ajax add, native drawer =================
   Our buy boxes post plain {% form 'product' %} forms. Left alone that is a
   full page navigation to /cart, which drops the customer onto an unbranded
   page. This intercepts the submit, adds through /cart/add.js, hands Horizon
   the freshly rendered cart sections, and slides the drawer open.        */
(function () {
  'use strict';

  var ADD_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

  function drawer() { return document.querySelector('cart-drawer-component'); }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function setPending(form, on) {
    /* form.id is shadowed by the form's own <input name="id">, so always read
       the attribute. */
    var fid = form.getAttribute('id') || '';
    var sel = fid ? 'button[type="submit"][form="' + fid + '"], #' + fid + ' button[type="submit"]' : '';
    var btns = sel ? document.querySelectorAll(sel) : form.querySelectorAll('button[type="submit"]');
    btns.forEach(function (b) {
      b.classList.toggle('is-adding', on);
      b.disabled = !!on;
      if (on) { b.dataset.prevLabel = b.dataset.prevLabel || b.innerHTML; }
      else if (b.dataset.prevLabel) { b.innerHTML = b.dataset.prevLabel; delete b.dataset.prevLabel; }
    });
    return btns;
  }

  function showError(form, message) {
    var host = form.closest('section') || form.parentElement;
    if (!host) return;
    var el = host.querySelector('.acart-err');
    if (!el) {
      el = document.createElement('p');
      el.className = 'acart-err';
      el.setAttribute('role', 'alert');
      form.parentElement.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('on');
    setTimeout(function () { el.classList.remove('on'); }, 6000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (e.defaultPrevented) return;          // someone else owns this form
    if (form.hasAttribute('data-no-ajax')) return;

    /* Capture phase: this runs before Horizon's product-form-component, which
       would otherwise take the submit and then fail on a missing ref. */
    e.preventDefault();
    e.stopPropagation();

    var fd = new FormData(form);
    var ids = sectionIds();
    if (ids.length) fd.append('sections', ids.join(','));
    fd.append('sections_url', window.location.pathname + window.location.search);

    setPending(form, true);

    fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        setPending(form, false);

        if (!res.ok || res.body.status) {
          showError(form, res.body.description || res.body.message || 'That could not be added right now.');
          return;
        }

        var sections = res.body.sections || {};

        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: form.getAttribute('id') || 'alvara-buy',
                data: {
                  source: 'alvara-buy',
                  itemCount: cart.item_count,
                  variantId: String(fd.get('id') || ''),
                  sections: sections,
                },
              },
            }));

            var d = drawer();
            if (d && typeof d.open === 'function') {
              d.open();
            } else {
              window.location.href = '/cart';
            }
          });
      })
      .catch(function (err) {
        setPending(form, false);
        showError(form, 'Network hiccup. Please try again.');
        if (window.console) console.error('alvara cart add', err);
      });
  }, true);
})();

/* Trust strip under the checkout button. Injected because the drawer markup
   belongs to the theme. Every line here is a verified fact. */
(function () {
  'use strict';
  var ITEMS = ['Secure checkout', 'Cancel anytime', 'Third-party lab tested'];

  function paint() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      if (ctas.querySelector('.acart-trust')) return;
      var ul = document.createElement('ul');
      ul.className = 'acart-trust';
      ITEMS.forEach(function (t) {
        var li = document.createElement('li');
        var i = document.createElement('i');
        i.className = 'ic ic-hex';
        i.setAttribute('aria-hidden', 'true');
        li.appendChild(i);
        li.appendChild(document.createTextNode(t));
        ul.appendChild(li);
      });
      ctas.appendChild(ul);
    });
  }

  try {
    document.addEventListener('cart:update', function () { setTimeout(paint, 80); });
    document.addEventListener('DOMContentLoaded', paint);
    paint();
    var d = document.querySelector('cart-drawer-component');
    if (d && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        /* guard against the observer re-firing on its own insertion */
        mo.disconnect();
        paint();
        mo.observe(d, { childList: true, subtree: true });
      });
      mo.observe(d, { childList: true, subtree: true });
    }
  } catch (e) { if (window.console) console.error('alvara cart trust', e); }
})();

/* ======================================================================
   ALVARA NAV adaptive ground detection
   Writes data-anav-ground="light|dark" onto .anav-root so the pill and the
   mega panel invert against whatever they are sitting on.

   Detection is by COMPUTED LUMINANCE, not by class name. .cream is this
   theme's cream section class but .pst-section is also background:var(--paper)
   with no .cream class, so a class list silently misses grounds.

   GEOMETRY TEST, v2. The first version required an element to span 90% of the
   viewport to count as ground. That was wrong: .cream is an INSET rounded
   sheet (border-radius --r-xl, negative vertical margins, black gutters left
   and right), so it measured about 85% and was skipped, and the pill stayed
   cream while sitting on cream. The test is now "does this element sit under
   the pill", measured as horizontal overlap against the pill's own rect. That
   is what actually matters, it is resolution independent, and it still
   excludes inner components that share the paper palette (.buybox and
   .ledger-card cap at 660px, .modal-card at 540px, all far below 80% of the
   1180px pill).

   Known limit: an element whose light ground comes from a background IMAGE
   reports a transparent backgroundColor and is treated as dark, because pixel
   sampling is not available. Override with data-anav-light, or exclude an
   element with data-anav-dark.
   ====================================================================== */
(function () {
  var root = document.querySelector('[data-anav]');
  if (!root) return;

  var pill = root.querySelector('.anav-wrap');
  if (!pill) return;

  var LUM_MIN = 140;     /* 0-255 perceived luminance to count as light */
  var ALPHA_MIN = 0.5;   /* below this the element is not really a ground */
  var COVER = 0.8;       /* share of the pill's width that must be covered */

  var ranges = [];
  var frame = null;

  function scrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function isLightSurface(el) {
    var c;
    try { c = window.getComputedStyle(el).backgroundColor; } catch (e) { return false; }
    if (!c) return false;
    var m = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s/]+([\d.]+))?/.exec(c);
    if (!m) return false;
    var a = m[4] === undefined ? 1 : parseFloat(m[4]);
    if (!(a >= ALPHA_MIN)) return false;
    var lum = (0.299 * +m[1]) + (0.587 * +m[2]) + (0.114 * +m[3]);
    return lum > LUM_MIN;
  }

  function coversPill(r, pr) {
    var overlap = Math.min(r.right, pr.right) - Math.max(r.left, pr.left);
    return overlap >= (pr.width * COVER);
  }

  function candidates() {
    var out = [];
    var seen = [];

    function add(list) {
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (seen.indexOf(el) === -1) { seen.push(el); out.push(el); }
      }
    }

    add(document.querySelectorAll('[id^="shopify-section"] > *'));
    add(document.querySelectorAll('[data-anav-light], [data-anav-dark]'));
    add(document.querySelectorAll('main > section, main > div'));
    add(document.querySelectorAll('.cream, .sheet, .pst-section'));
    return out;
  }

  function measure() {
    var y = scrollTop();
    var pr = pill.getBoundingClientRect();
    var out = [];
    var els = candidates();

    for (var i = 0; i < els.length; i++) {
      var el = els[i];

      /* the nav is never its own ground */
      if (el.closest && el.closest('[data-anav]')) continue;
      if (el.hasAttribute && el.hasAttribute('data-anav-dark')) continue;

      var r = el.getBoundingClientRect();
      if (r.height < 40) continue;

      var forced = el.hasAttribute && el.hasAttribute('data-anav-light');
      if (!forced) {
        if (!coversPill(r, pr)) continue;
        if (!isLightSurface(el)) continue;
      }

      out.push([r.top + y, r.bottom + y]);
    }

    ranges = out;
    /* exposed for debugging: how many light grounds were found */
    root.setAttribute('data-anav-grounds', out.length);
  }

  function apply() {
    frame = null;
    var r = pill.getBoundingClientRect();
    var probe = scrollTop() + r.top + (r.height / 2);
    var light = false;

    for (var i = 0; i < ranges.length; i++) {
      if (probe >= ranges[i][0] && probe < ranges[i][1]) { light = true; break; }
    }

    root.setAttribute('data-anav-ground', light ? 'light' : 'dark');
  }

  function schedule() {
    if (frame === null) frame = requestAnimationFrame(apply);
  }

  function remeasure() { measure(); apply(); }

  try {
    remeasure();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', remeasure);
    window.addEventListener('load', remeasure);
    document.addEventListener('DOMContentLoaded', remeasure);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(remeasure);
    }
    /* lazy media and reveal animations change section heights after paint */
    if ('ResizeObserver' in window) {
      var rt = null;
      var ro = new ResizeObserver(function () {
        clearTimeout(rt);
        rt = setTimeout(remeasure, 120);
      });
      ro.observe(document.body);
    }
  } catch (e) {
    if (window.console) console.error('alvara nav ground', e);
  }
})();

/* ======================================================================
   ALVARA PARTNER form success state
   Shopify posts the native contact form and redirects back with
   ?contact_posted=true plus whatever return_to hash was set. This mirrors the
   existing customer_posted handler used by the Hive form: hide the form,
   reveal the .form-ok paragraph, scroll it into view.

   Both the header panel form and the homepage form use return_to '/#partner-ok'
   and identical contact[] field names, so one handler covers both and the two
   submissions arrive in one inbox reading the same way.
   ====================================================================== */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;
    if (window.location.hash !== '#partner-ok') return;

    var form = document.getElementById('partnerForm');
    var ok = document.getElementById('partnerOk');
    if (form) {
      var wrap = form.closest ? form.closest('.pt-apply') : null;
      form.style.display = 'none';
      var head = wrap ? wrap.querySelector('.pt-apply-head') : null;
      if (head) head.style.display = 'none';
    }
    if (ok) {
      ok.classList.add('on');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      ok.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
  } catch (e) {
    if (window.console) console.error('alvara partner form', e);
  }
})();
